import React from 'react';
import Link from 'components/link';
import PlaceOutlined from '@mui/icons-material/PlaceOutlined';
import styles from './style.module.scss';

export interface NearbyCity {
  name: string;
  slug: string;
}

export interface NearbyCitiesPillsProps {
  cities: readonly NearbyCity[];
  /** Cap on the number of pills rendered. */
  limit?: number;
}

/**
 * Pill/chip row linking out to nearby cities' own info pages.
 */
const NearbyCitiesPills = ({ cities, limit = 10 }: NearbyCitiesPillsProps) => {
  const rows = (cities || []).filter(city => city?.name && city?.slug).slice(0, limit);

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className={styles.component}>
      {rows.map(city => (
        <Link key={city.slug} href={`/${city.slug}-info`} className={styles.pill}>
          <PlaceOutlined className={styles.icon} />
          {city.name}
        </Link>
      ))}
    </div>
  );
};

export default NearbyCitiesPills;
